import { computed } from "@nuxtjs/composition-api";
import { useCustomerStore } from "@wemade-vsf/customer";
import { useConfigStore } from "@wemade-vsf/core";
import { getPrice } from "../../getters/productGetters";
function useCustomerPricing() {
  const configStore = useConfigStore();
  const customerStore = useCustomerStore();
  const defaultPriceIncludesTax = configStore.arePricesIncludingTax;
  const displayPricesIncludingTax = computed(() => {
    var _a;
    if (customerStore.user && "display_prices_inc_tax" in customerStore.user) {
      return customerStore.user.display_prices_inc_tax;
    }
    if (!customerStore.user) {
      if ((_a = configStore.storeConfig) == null ? void 0 : _a.storefront) {
        return configStore.storeConfig.storefront.display_prices_inc_tax;
      }
    }
    return defaultPriceIncludesTax;
  });
  const calculateTax = (value, includesTax, rate = 25) => {
    if (includesTax) {
      return value / (100 + rate) * rate;
    }
    return value / 100 * rate;
  };
  const getNetPrice = (price, rate = 25) => {
    if (!defaultPriceIncludesTax) {
      return price;
    }
    let netPrice = {
      regular: null,
      special: null,
      maximum: null,
      final: null
    };
    Object.keys(netPrice).forEach((p) => {
      netPrice[p] = price[p] ? price[p] - calculateTax(price[p], true, rate) : null;
    });
    return netPrice;
  };
  const getPriceForProduct = (product) => {
    const price = getPrice(product, defaultPriceIncludesTax);
    if (!product)
      return price;
    if (defaultPriceIncludesTax === displayPricesIncludingTax.value) {
      return price;
    }
    if (defaultPriceIncludesTax && !displayPricesIncludingTax.value) {
      return getNetPrice(price, product.applied_tax_rate || 25);
    }
    if (!defaultPriceIncludesTax && displayPricesIncludingTax.value) {
      let netPrice = price;
      Object.keys(netPrice).forEach((p) => {
        netPrice[p] = price[p] + calculateTax(price[p], false, product.applied_tax_rate || 25);
      });
      return netPrice;
    }
  };
  const getPriceForConfiguredVariant = (product) => {
    var _a, _b;
    const priceProduct = (_b = (_a = product == null ? void 0 : product.configurable_product_options_selection) == null ? void 0 : _a.variant) != null ? _b : product;
    return getPriceForProduct(priceProduct);
  };
  const getPriceForGroupedProduct = (product) => {
    var _a, _b;
    const evalProductPrice = (p) => {
      const { regular, special } = getPriceForProduct(p);
      return regular > special && special !== null ? special : regular;
    };
    return (_b = (_a = product.items) == null ? void 0 : _a.reduce(
      (acc, curr) => curr.qty * evalProductPrice(curr.product) + acc,
      0
    )) != null ? _b : 0;
  };
  const showPriceForProduct = (product) => {
    var _a, _b;
    if (!customerStore.user) {
      return !((_b = (_a = configStore.storeConfig) == null ? void 0 : _a.storefront) == null ? void 0 : _b.hide_prices);
    }
    return !customerStore.user.hide_prices;
  };
  const showCartButtonForProduct = (product) => {
    var _a, _b;
    if (!customerStore.user) {
      return !((_b = (_a = configStore.storeConfig) == null ? void 0 : _a.storefront) == null ? void 0 : _b.hide_cart_button);
    }
    return !customerStore.user.hide_cart_button;
  };
  return {
    displayPricesIncludingTax,
    getNetPrice,
    getPriceForProduct,
    getPriceForConfiguredVariant,
    getPriceForGroupedProduct,
    showPriceForProduct,
    showCartButtonForProduct
  };
}
export {
  useCustomerPricing
};
